.kdx-article-detail-hero {
    background: $articleHeroBG;
    color: $articleHeroText;

    .back-btn {
        display: inline-flex;
        align-items: center;
        color: $articleHeroBackBtn;
        margin: 24px 0 75px 0;
        @include text-size(15);
        @include line-height(20);
        font-weight: 600;
        text-decoration: none;
        position: relative;

        &.mobile { display: none; }
        svg {
            @include svg-format(14px, 14px, currentColor);
            margin-right: 5px;
            transition: transform .3s ease-in-out;
            // margin-bottom: 2px;
        }
        &:after {
            content: '';
            background: currentColor;
            height: 1px;
            width: 0px;
            position: absolute;
            top: 100%;
            left: 0;
            transition: width .3s ease-in-out;
        }
        &:hover, &:focus {
            outline: none;
            color: $articleHeroBackBtn;
    
            &:after { width: 100%; }
            svg { 
                transform: translateX(-4px);
            }
        }
    }
    .heading { 
        color: $articleHeroText; 
        margin: 0 0 16px 0;
    }
    .tags {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		width: 100%;			
		overflow: hidden;
		text-overflow: ellipsis;			

		.tag {
			color: #606060;
			@include text-size(15);
			@include line-height(19);
			font-family: $font-family-secondary;
			display: inline-block;
			background: #FFF;
			border-radius: 3px;
			border: 1px solid $articleTagBorder;
			margin-right: 5px;
			padding: 3px;
			text-decoration: none;
			white-space: nowrap;				

			&:nth-child(n+4) { 				
				display: none;
			}
			&:nth-child(3):not(:last-child) {
				position: relative; 				
	
				&::after {
					content: '...';
					position: absolute;
					bottom: 5px;
					left: 100%;
					opacity: 1;
					margin-left: 8px;
					color: #6E6E6E;
					@include text-size(25);					
				}
			}			
			&:last-child { margin-right: 0; }
			&:hover, &:focus {
				background: $articleTagHover;
				border: 1px solid $articleTagHover;
				color: #000;
			}
		}
	}
    .article-info {

        p { padding: 0 0 8px 0; }
        a { color: #fff; font-weight: 500; }
    }
    .kdx-share-icons {
        margin: 75px 0 55px 0;

        li {
            a {
                color: $articleHeroSocialIcons;
                @include line-height(22);

                &:hover, &:focus { color: $articleHeroSocialIconsHover; }

            }
        }        
    }
    .photo {
        height: 100%;
        position: relative;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: top left;
        }
    }
}


@include media-breakpoint-down(lg) {
    .kdx-article-detail-hero {
        .photo {
            img {
                object-position: 50% 20%;  
            }
        }
    }
}



@include media-breakpoint-down(md) {
    .kdx-article-detail-hero {
        background: $articleHeroBGMobile;

        .row { flex-direction: column-reverse; }
        .back-btn {
            margin-bottom: 16px;
            
            &.desktop { display: none; }
            &.mobile { display: inline-flex; }
        }
        .photo {
            margin-bottom: 16px;
            height: 238px;
            
            img {
                position: relative;
            }
        }
        .tags {

            .tag {
                @include text-size(10);
                @include line-height(13);
            }
        }
        .article-info {
            @include text-size(14);
            @include line-height(19);
        }
        .kdx-share-icons {
            margin-top: 24px;
            margin: 16px 0 32px 0;
        }
    }
}
